import { DeliveryMethod, OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useClearConflictingData from "./useClearConflictingData";

type TClearConflictingSenderDataReturn = {
  handleStartingCountryChange: (countryCode: string) => void;
  handleDeliveryMethodChange: (deliveryMethod: DeliveryMethod) => void;
};

const useClearConflictingSenderData = (): TClearConflictingSenderDataReturn => {
  const { defaultUserAddress } = useOrderData();
  const defaultAddressCountryCode = defaultUserAddress?.countryCode || undefined;

  const { handleCountryChange: handleStartingCountryChange, handleDeliveryMethodChange } = useClearConflictingData({
    prefillAddressCountryCode: defaultAddressCountryCode,
    prefillLockerCountryCode: defaultAddressCountryCode,
    fieldNames: {
      country: OrderFields.STARTING_COUNTRY,
      deliveryMethod: OrderFields.DELIVERY_METHOD,
      name: OrderFields.SENDER_NAME,
      phoneNumber: OrderFields.SENDER_PHONE_NUMBER,
      email: OrderFields.SENDER_EMAIL,
      street: OrderFields.SENDER_STREET,
      houseNo: OrderFields.SENDER_HOUSE_NO,
      flatNo: OrderFields.SENDER_FLAT_NO,
      city: OrderFields.SENDER_CITY,
      zipCode: OrderFields.SENDER_ZIP_CODE,
      locker: OrderFields.RETURN_LOCKER,
      lockerName: OrderFields.RETURN_LOCKER_NAME,
      pickupDate: OrderFields.PICKUP_DATE,
      pickupTimeFrom: OrderFields.PICKUP_TIME_FROM,
      pickupTimeTill: OrderFields.PICKUP_TIME_TILL,
    },
    prefill: {
      name: defaultUserAddress?.contactName || undefined,
      phoneNumber: defaultUserAddress?.contactPhone || undefined,
      email: defaultUserAddress?.contactEmail || undefined,
      street: defaultUserAddress?.street || undefined,
      houseNo: defaultUserAddress?.streetNumber || undefined,
      flatNo: defaultUserAddress?.flatNo || undefined,
      city: defaultUserAddress?.city || undefined,
      zipCode: defaultUserAddress?.zip || undefined,
      locker: defaultUserAddress?.returnLockerId || undefined,
      lockerName: defaultUserAddress?.returnLocker?.name || undefined,
    },
    addressDeliveryMethods: [DeliveryMethod.DoorToDoor, DeliveryMethod.DoorToPudo],
    lockerDeliveryMethods: [DeliveryMethod.PudoToPudo, DeliveryMethod.PudoToDoor],
    fromLockerDeliveryMethods: [DeliveryMethod.PudoToPudo, DeliveryMethod.PudoToDoor],
  });

  return { handleStartingCountryChange, handleDeliveryMethodChange };
};
export default useClearConflictingSenderData;
